import CardInfo from "@/modules/cards/models/CardInfo";
import {CardRepository} from "@/modules/cards/adapter/CardRepository";
import {Transaction} from "@/modules/cards/models/Transaction";
import {TransactionsRange} from "@/modules/cards/models/TransactionsRange";
import {Card} from "@/modules/cards";

export class CardService {

    private readonly cardRepository: CardRepository;

    constructor(params: { cardRepository: CardRepository }) {
        this.cardRepository = params.cardRepository;
    }

    public async getCardUrl(card:string):Promise<string> {
        return this.cardRepository.getCardUrl(card);
    }
    public async lockCard(card: any): Promise<void> {
        return this.cardRepository.lockCard(card);
    }
    public async getCardInfo(cardId: string): Promise<CardInfo> {
        return this.cardRepository.getCardInfo(cardId);
    }
    public async getCardInfoManual(cardNr: string): Promise<CardInfo> {
        return this.cardRepository.getCardInfoManual(cardNr);
    }
    public async cancelTransaction(transaction: Transaction): Promise<void> {
        return this.cardRepository.cancelTransaction(transaction);
    }

    public async transferCard(cardId: string, newCardId:string): Promise<void> {
        return this.cardRepository.transferCard(cardId,newCardId);
    }
    public async unlockCard(card: Card): Promise<void> {
        return this.cardRepository.unlockCard(card);
    }
    public async getReport(reportUrl:string, reportNr:number, period:number, showPeriod:boolean, range?: {start: Date, end: Date}): Promise<string> {
        return this.cardRepository.getReport(reportUrl,reportNr,period,showPeriod,range);
    }
}
